import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import Footer from "../components/Footer";
import Label from "../components/Label";
function ITServices(props) {
  return (
    <>
      <header id="header">
        <div className="intro">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div
                  className="col-md-8 col-md-offset-2 intro-text"
                  style={{ marginBottom: -100 }}
                >
                  <ScrollAnimation animateIn="fadeInLeft" delay={0.5 * 1000}>
                    <h1 style={{ fontFamily: "Audiowide", color: "orange" }}>
                      IT Services
                      <span></span>
                    </h1>
                  </ScrollAnimation>
                  <ScrollAnimation animateIn="fadeInRight" delay={0.9 * 1000}>
                    <p style={{ fontFamily: "monospace" }}>
                      The application of business and technical expertise to
                      enable organizations in the creation, management and
                      optimization. Providing consulting services to
                      organizations to improve their performance.
                    </p>
                  </ScrollAnimation>
                  <a
                    href="#features"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    Learn More
                  </a>
                  <Label />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Footer />
    </>
  );
}

export default ITServices;
